import useFetch from "../../../hooks/useFetch";
import {useModal} from "../../../store/admin/ModalProvider";
import {useEffect} from "react";
import CONFIG from "../../../config/_config";
import {Box, Button, IconButton, Stack} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {DataGrid} from "@mui/x-data-grid";
import GridNoRowsOverlay from "../../_atoms/admin/GridNoRowsOverlay";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import useBreakpoint from "../../../hooks/useBreakpoint";
const ProductActionButtons = (props) => {
    const {makeRequest, response} = useFetch();
    const {openModal} = useModal();
    const {getBreakPointName} = useBreakpoint();
    const showTextInButton = (getBreakPointName() === 'lg' || getBreakPointName() === 'xl');

    useEffect(() => {
        if (response && response.state === 'success'){
            if ('getProduct' in response.requestData){
                openModal('ProductFormModal', {
                    editMode: true,
                    product: response.data
                })
            } else if ('deleteProduct' in response.requestData){
                const event = new CustomEvent('productsChanged',
                    {
                        bubbles: true,
                        cancelable: true
                    })
                window.dispatchEvent(event);
            }
        }
    }, [response]);

    const onEditBtnClickHandler = () => {
        makeRequest(CONFIG.adminApiUrl + 'product_ajax.php', 'post', {
            getProduct: 1,
            id: props.params.row.id
        });
    }

    const onDeleteBtnClickHandler = () => {
        openModal('QuestionModal', {
            title: `Eliminazione prodotto: ${props.params.row.name}`,
            questionText: `Vuoi davvero eliminare questo prodotto?`,
            onConfirm: () => {
                makeRequest(CONFIG.adminApiUrl + 'product_ajax.php', 'post', {
                    deleteProduct: 1,
                    id: props.params.row.id
                });
            }
        })

    }
    return <>
        <Stack height='100%' spacing={1} direction='row' justifyContent="center" alignItems="center">
            {showTextInButton && <>
                <Button variant='contained' onClick={onEditBtnClickHandler} startIcon={<EditIcon />}>
                    Modifica
                </Button>
                <Button variant='outlined' onClick={onDeleteBtnClickHandler} startIcon={<DeleteIcon />}>
                    Elimina
                </Button>
            </>}
            {!showTextInButton && <>
                <IconButton color='primary' aria-label='Modifica' onClick={onEditBtnClickHandler}>
                    <EditIcon />
                </IconButton>
                <IconButton color='primary' aria-label='Elimina' onClick={onDeleteBtnClickHandler}>
                    <DeleteIcon />
                </IconButton>
            </>}
        </Stack>
    </>
}

const ProductsListTable = (props) => {
    const {getBreakPointName} = useBreakpoint();
    const showTextInButton = (getBreakPointName() === 'lg' || getBreakPointName() === 'xl');

    let columns = [
        {
            field: 'name',
            maxWidth: 250,
            headerName: 'Nome',
            flex: 1
        },{
            field: 'description',
            headerName: 'Descrizione',
            flex: 1,
            renderCell: (params) => {
                return <Stack alignItems='flex-start' justifyContent='center' color='grey' flexWrap='wrap'>
                    {params.row.description}
                </Stack>
            }
        }, {
            field: 'price',
            headerName: 'Prezzo',
            maxWidth: 80,
            renderCell: (params) => {
                return `€${params.row.price}`;
            }
        }, {
            field: 'in_news',
            headerName: 'Novità',
            maxWidth: 60,
            renderCell: (params) => {
                return <Stack justifyContent='center' alignItems='center' height='100%'>
                    {params.row.in_news === 1 && <CheckBoxIcon />}
                    {!params.row.in_news && <CheckBoxOutlineBlankIcon />}
                </Stack>
            }
        }, {
            field: 'actions',
            headerName: 'Azioni',
            flex: 1,
            minWidth: showTextInButton ? 230 : 50,
            maxWidth: showTextInButton ? 260 : 100,
            sortable: false,
            disableClickEventBubbling: true,
            renderCell: (params) => {
                return <ProductActionButtons params={params} />
            }
        }
    ];

    if (getBreakPointName() === 'xs' || getBreakPointName() === 'sm'){
        columns = columns.filter(column => column.field !== 'description' && column.field !== 'in_news');
    }

    return <>
        <Box>
            <DataGrid
                autoHeight
                slots={{ noRowsOverlay: GridNoRowsOverlay }}
                sx={{ '--DataGrid-overlayHeight': '300px' }}
                rows={props.data}
                columns={columns}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 25
                        }
                    }
                }}
                pageSizeOptions={[10,25,50,100]}
                loading={props.loading}
                disableRowSelectionOnClick
            />
        </Box>
    </>
}



export default ProductsListTable;